import { BaseService } from './base.service';
import { CustomResponseEntity, PaginationParams } from '../types/common';
import { TrainingDto, CreateTrainingDto, UpdateTrainingDto } from '../types/dtos/training';
import { api } from '../client/axiosClient';

/**
 * TrainingService handles CRUD operations for trainings.
 *
 * URL Pattern: /api/v1/trainings
 * Organization context is provided via X-Organization-Id header (injected by axiosClient).
 *
 * Migration: The organizationId parameter has been removed from URL paths. The backend
 * extracts organization context from the X-Organization-Id header for tenant scoping.
 *
 * VAL-FE-006: Training Service Works with Header-Based Auth
 * The axiosClient automatically includes X-Organization-Id header from localStorage,
 * which the backend uses for tenant context validation via TenantContextHolder.
 *
 * @param _organizationId - Deprecated: Organization ID (no longer used, kept for backward compatibility)
 */

const BASE_PATH = '/api/v1/trainings';

export class TrainingService extends BaseService<
  TrainingDto,
  CreateTrainingDto,
  UpdateTrainingDto
> {
  /**
   * @param _organizationId - Deprecated: Organization ID (no longer used, kept for backward compatibility)
   */
  constructor(_organizationId?: string) {
    super(BASE_PATH);
  }

  findAll(params?: PaginationParams): Promise<CustomResponseEntity<TrainingDto[]>> {
    return api.get(this.baseUrl, { params });
  }
}

/**
 * Factory function to create a TrainingService instance
 * @param _organizationId - Deprecated: Organization ID (no longer used, kept for backward compatibility)
 */
export const createTrainingService = (_organizationId?: string) =>
  new TrainingService(_organizationId);

